// @flow
import { InstanceSurveysActionTypes } from './constants';

type InstanceSurveysAction = { type: string, payload: {} | string };

// common success
export const instanceSurveysApiResponseSuccess = (actionType: string, data: any): InstanceSurveysAction => ({
    type: InstanceSurveysActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const instanceSurveysApiResponseError = (actionType: string, error: string): InstanceSurveysAction => ({
    type: InstanceSurveysActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getInstanceSurvey = (id: string): InstanceSurveysAction => ({
    type: InstanceSurveysActionTypes.GET_INSTANCE_SURVEY,
    payload: { id },
});

export const addInstanceSurvey = (instanceSurvey:any):InstanceSurveysAction=>({
    type:InstanceSurveysActionTypes.ADD_INSTANCE_SURVEY,
    payload:instanceSurvey
})
export const updateInstanceSurvey = (instanceSurvey:any):InstanceSurveysAction=>({
    type:InstanceSurveysActionTypes.UPDATE_INSTANCE_SURVEY,
    payload:instanceSurvey
})
export const deleteInstanceSurvey = (id:string):InstanceSurveysAction=>({
    type:InstanceSurveysActionTypes.DELETE_INSTANCE_SURVEY,
    payload:{id}
})

export const listInstanceSurveys = (params:any): InstanceSurveysAction => ({
    type: InstanceSurveysActionTypes.LIST_INSTANCE_SURVEYS,
    payload: params,
});

export const addInstanceSurveyQr = (instanceSurvey:any):InstanceSurveysAction=>({
    type:InstanceSurveysActionTypes.ADD_INSTANCE_SURVEY_QR,
    payload:instanceSurvey
})

export const updateInstanceSurveyQr = (instanceSurvey:any):InstanceSurveysAction=>({
    type:InstanceSurveysActionTypes.UPDATE_INSTANCE_SURVEY_QR,
    payload:instanceSurvey
})

export const resetInstanceSurveys = (): InstanceSurveysAction => ({
    type: InstanceSurveysActionTypes.RESET,
    payload: {},
});

